import React, {Fragment, useEffect, useState} from 'react';
import {Button, Col, Container, Form, Row, Table} from 'react-bootstrap';
import {useParams} from "react-router-dom";
import {
	GenericModelViewer
} from "../../Common/GenericModelViewer";
import {
    Glyphicon,
} from "../../Common/GlyphIcon";
import {
    ObjectUtils
} from "../../../Utils";
import {useChangePage} from "../../../Hooks/NavigationHooks";


import {
	useChangeContext,
	useGetQueryStringParameter,
} from "../../../Hooks/RouteHooks";
import {
    useMakePageRequest,
} from "../../../Hooks/RequestHooks";
import {
    useEditContextNodeId,
    usePermission
} from "../../../Hooks/PermissionHooks";


// import {service as ConservationActionService} from '../../../Services/ConservationActionService';
// import {service as ConservationActionStatisticService} from '../../../Services/ConservationActionStatisticService';
// import {service as ConservationActionTypeService} from '../../../Services/ConservationActionTypeService';
import {service as ProcedureService} from '../../../Services/ProcedureService';
// import {service as ProjectService} from '../../../Services/ProjectService';
import {service as SampleEventService} from '../../../Services/SampleEventService';
// import {service as SurveyTypeService} from '../../../Services/SurveyTypeService';
// TODO CLEAN UP IMPORTS
// import {SampleEvent} from "../../../Models/StreamBank/SampleEvent";
import {MonitoringEvent} from "../../../Models/StreamBank/MonitoringEvent";
import {ModelingEvent} from "../../../Models/StreamBank/ModelingEvent";

import {useClassNames} from "../../../Hooks/StyleHooks";

import {SbMap} from "../../Common/SbMap/SbMap";
import {useDeleteModelConfirmationDialog, usePrimeCache} from "../../../Hooks/ServiceHooks";
// import {service as OfflineDataService} from "../../../Services/OfflineDataService";
// import {useSelector} from "react-redux";
import {PhotoMonitoring} from "./PhotoMonitoring";
import {QuantVeg} from "./QuantVeg";
import {useValidations} from "../../../Hooks/GenericModelHooks";

export const SampleEventViewPage = () => {
    usePrimeCache([ProcedureService]);
    
    const service = SampleEventService;

    const classNames = useClassNames('sb-sample-event-view-page');
    const getQueryStringParameter = useGetQueryStringParameter();
    const makePageRequest = useMakePageRequest();
    const permission = usePermission();
    const editContextNodeId = useEditContextNodeId();
    const changeContext = useChangeContext();
    const changePage = useChangePage();

    const [sampleEvent, setSampleEvent] = useState(null);
    const [existingSampleEvent, setExistingSampleEvent] = useState(null);
    const [validations, setValidations, isValid] = useValidations();
    
    const [photoPoints, setPhotoPoints] = useState([]);
    const [cameraPoints, setCameraPoints] = useState([]);
    const [editMode, setEditMode] = useState(false);
    
    const [DeleteModelConfirmationDialog, setDeleteDialog] = useDeleteModelConfirmationDialog();

    const {sampleEventId, conActId, projId} = useParams();
    const conservationActionId = conActId;
    const projectId = projId || {};
    const contextNodeId = sampleEvent?.contextNodeId;
    const currentProcedure = ProcedureService.CachedValueById(sampleEvent?.procedureId)?.result;

    useEffect(() => {
        if (conservationActionId) {
            loadData();
        }
    }, [conservationActionId]);

    const loadData = () => {
        // a new sampleEvent has nothing to load; only existing events fetch data
        if(sampleEventId !== "new") {
            makePageRequest(
                _ => Promise.all([
                    service.Get(sampleEventId),
                ]),
                ([sampleEventData]) => {
                    setSampleEvent(sampleEventData.result);
                    setEditMode(false);
                }
            );
        }
    };

    const enterEditMode = () => {
        setEditMode(true);
        setExistingSampleEvent(ObjectUtils.Clone(sampleEvent));
    };

    const exitEditMode = () => {
        if(existingSampleEvent) {
            setEditMode(false);
            setSampleEvent(ObjectUtils.Clone(existingSampleEvent));
            setExistingSampleEvent(null);
        } else {
            changeContext?.({sampleEvent: null});
        }
    };

    const updateSampleEvent = (sampleEvent) => {
        setSampleEvent(sampleEvent);
    };

    const saveSampleEvent = () => {
        if(sampleEvent.sampleEventId) {
            makePageRequest(
                () => service.Update(sampleEvent),
                (x) => {
                    setEditMode(false);
                    setSampleEvent(x.result);
                }
            );
        } else {
            makePageRequest(
                () => service.Create(sampleEvent),
                (x) => {
                    let newPath = window.location.pathname.replace("new", x.result.sampleEventId);
                    changePage(newPath);
                },
            );
        }
    };

    const getHiddenSections = () => {
        let ret = [];

        // if(sampleEvent) {
        //     let conservationActionType = conservationActionTypes.find((x) => x.conservationActionTypeId == sampleEvent.conservationActionTypeId);
        //
        //     if(conservationActionType) {
        //         ret = ret.filter((x) => x !== conservationActionType.name);
        //     }
        // }

        return ret;
    };

    const canEdit = () => {
        if(sampleEvent) {
            if(permission('update_conservation_action')) {
                return editContextNodeId(sampleEvent.contextNodeId);
            }
        }
        return false;
    };

    const canDelete = () => {
        if(sampleEvent) {
            if(permission('delete_conservation_action')) {
                return editContextNodeId(sampleEvent.contextNodeId);
            }
        }

        return false;
    };
    
    if(!sampleEvent) {
        return null;
    }
    const model = sampleEvent.sampleEventTypeId === 1 ? new MonitoringEvent() : new ModelingEvent();

    const latitude = sampleEvent?.Location?.latitude;
    const longitude = sampleEvent?.Location?.longitude;
    const accuracy = sampleEvent?.Location?.accuracy;

    const renderRightColumnItems = () => {
        switch (currentProcedure?.code) {
            case 'photo':
                return <PhotoMonitoring sampleEvent={sampleEvent} />;
            case 'quant-veg':
                return <QuantVeg sampleEvent={sampleEvent} />;
            default:
                return (sampleEvent?.sampleEventId && latitude && longitude) ?
                    <SbMap
                        Lat={latitude}
                        Lng={longitude}
                        Zoom={11}
                        Markers={[
                            {
                                key: sampleEvent.sampleEventId,
                                lat: latitude,
                                lng: longitude,
                                accuracy,
                                marker: !permission('authenticated_user') ? 'circle' : 'both',
                                content:
                                    <div>{sampleEvent.name ?? service.ModelName}<br/>{sampleEvent.locationDescription}
                                    </div>
                            }
                        ]}
                    /> :
                    null
        }
    }

    return <Container className={classNames}>
        <DeleteModelConfirmationDialog service={service} />
        <Row>
            <Col xs={12} md={6}>
                <h2 className="atomic-sectionheader">
                    <div className="float-right btn-edit">
                        {
                            editMode ? [
                                    <Button
                                        variant="save"
                                        key={1}
                                        onClick={() => saveSampleEvent()}
                                        disabled={!isValid}
                                    >
                                        Save
                                    </Button>,
                                    <Button
                                        variant="cancel"
                                        key={2}
                                        onClick={() => exitEditMode()}
                                    >
                                        Cancel
                                    </Button>,
                                    (conservationActionId !== 'new' && canDelete()) ?
                                        <Button
                                            variant="delete"
                                            key={3}
                                            onClick={() => setDeleteDialog(true)}
                                        >
                                            Delete
                                        </Button> :
                                        null
                                ] :
                                (
                                    canEdit() ?
                                        <Button
                                            variant="link"
                                            onClick={() => enterEditMode()}>
                                            <Glyphicon glyph="pencil"/>Edit</Button> :
                                        null
                                )
                        }
                    </div>
                    <span className="sb-conservation-action-header">{sampleEvent.name ?? service.ModelName}</span>
                    <span className="sb-print-show">{sampleEvent.name ?? service.ModelName}</span>
                </h2>

                {
                    sampleEvent ?
                        <GenericModelViewer
                            IsNewModel={conservationActionId === "new"}
                            EditMode={editMode}
                            Data={sampleEvent}
                            Update={updateSampleEvent}
                            OnValidationUpdate={setValidations}
                            Model={model}
                            HideGroups={getHiddenSections()}
                        /> :
                        null
                }
            </Col>
            <Col xs={12} md={{span: 5, offset: 1}}>
                {renderRightColumnItems()}
            </Col>
        </Row>
    </Container>;
};
